module.exports = __webpack_public_path__ + "img/101.228b4343.png";